import { Controller } from "@hotwired/stimulus"

// Watches the date / time / service inputs of an appointment form and
// updates a turbo-frame's src with a conflict-check request. The frame
// renders a single status row (available / conflict / past / pending).
//
// Targets:
//   dateInput     — hidden input holding the ISO date (YYYY-MM-DD).
//                   Required. (Datepicker controller's hidden target.)
//   timeInput     — hidden input holding the time (HH:MM, 24-hour).
//                   Required for a definitive answer; without it the
//                   server returns the "pending" state.
//   serviceInput  — input holding the service id. Optional. If absent,
//                   the URL value should already carry service_id (e.g.,
//                   reschedule form, where service is fixed).
//   frame         — wrapping element containing a <turbo-frame> child.
//
// Values:
//   url — base URL for the conflict_check endpoint. May include
//         query params like exclude_id, service_id, frame_id; the
//         controller appends date / time / service_id (when present)
//         on each update.
export default class extends Controller {
  static targets = ["dateInput", "timeInput", "serviceInput", "frame"]
  static values = { url: String }

  update() {
    if (!this.hasFrameTarget || !this.urlValue) return
    if (!this.hasDateInputTarget) return

    const url = new URL(this.urlValue, window.location.origin)
    const date = this.dateInputTarget.value
    if (date) url.searchParams.set("date", date)

    if (this.hasTimeInputTarget && this.timeInputTarget.value) {
      url.searchParams.set("time", this.timeInputTarget.value)
    }
    if (this.hasServiceInputTarget && this.serviceInputTarget.value) {
      url.searchParams.set("service_id", this.serviceInputTarget.value)
    }

    const frame = this.frameTarget.querySelector("turbo-frame")
    if (frame) frame.setAttribute("src", url.toString())
  }
}
